import { Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { CheckboxComponent, UtcToLocalDateTimePipe } from '@cms/shared-library';
import { TranslateService } from '@ngx-translate/core';
import { EnrollmentFlowType, EnrolmentStatus } from 'src/app/models/class-enrolment.model';
import { GroupEnrolment } from 'src/app/models/course-dto.model';
import { FormatUtil } from 'src/app/utils/format.util';


@Component({
    selector: 'app-enrollment-enrolled-tab',
    templateUrl: './enrollment-enrolled-tab.component.html',
    styleUrls: ['./enrollment-enrolled-tab.component.scss'],
    standalone: false
})
export class EnrollmentEnrolledTabComponent implements OnInit, OnChanges {

  formatUtil = FormatUtil
  utcDatePipe: UtcToLocalDateTimePipe
  currentLang: string = 'en';
  @Input() classEnrollments: GroupEnrolment[] = [];
  @Input() enrolmentStatus: string;
  @Output() confirmedSelectionchanges: EventEmitter<any> = new EventEmitter<any>()
  @ViewChild('masterCheckBox') masterCheckBox: CheckboxComponent;
  @ViewChildren('childCheckBox') childCheckBoxList: QueryList<CheckboxComponent>;

  isLearnersDetailsInComplete: boolean = false;
  canDisableSubmitROC: boolean = false;
  selectedLearnerIds: string[] = [];
  ENROLLMENT_FLOW_TYPE = EnrollmentFlowType;
  constructor(public translateService: TranslateService) { }


  ngOnChanges(changes: SimpleChanges): void {
    this.checkLearnerIncompleteInformation();
  }

  ngOnInit(): void {
    this.currentLang = this.translateService.currentLang;
    this.checkLearnerIncompleteInformation()
  }

  setChildCheckBox(checked: any): void { 
    this.childCheckBoxList.forEach(checkBox => checkBox.checked = checked);
    let selectedConfirmedRegistrationIds: string[] = [];
    this.classEnrollments.forEach(x => {
      x.Enrolments.forEach(y => {
        if (y.EnrolmentStatus == (this.enrolmentStatus == 'SuccessfullyCompleted' ? EnrolmentStatus.EnrolmentStatusCompleted : EnrolmentStatus.EnrolmentStatusConfirmed)) selectedConfirmedRegistrationIds.push(y.RegistrationId!);
      })
    }); 
    this.canDisableSubmitROC = checked ? this.checkLearnerIncompleteInformation() : false;
    this.selectedLearnerIds = checked ? selectedConfirmedRegistrationIds : [];
    this.confirmedSelectionchanges.emit({ checked: checked, selectedConfirmedRegistrationIds: this.selectedLearnerIds, isLearnerInfoIncomplete: this.canDisableSubmitROC });
  }

  setMasterCheckBox(checked: any, registrationId: any): void {
    let masterCheckFlag = true;
    this.childCheckBoxList.forEach(checkBox => { if (!checkBox.checked) masterCheckFlag = false; });
    if (checked) this.selectedLearnerIds.push(registrationId)
    else {
      let index = this.selectedLearnerIds.indexOf(registrationId)
      this.selectedLearnerIds.splice(index, 1);
    }
    this.masterCheckBox.checked = masterCheckFlag;

    this.checkIfSeletedLearnerIncompleteInfo(); 
    this.confirmedSelectionchanges.emit({ checked: checked, selectedConfirmedRegistrationIds: this.selectedLearnerIds, isLearnerInfoIncomplete: this.canDisableSubmitROC });
  }

  checkLearnerIncompleteInformation(): boolean {
    let isLearnerInfoIncomplete = false;
    if (this.classEnrollments.length > 0) {
      this.classEnrollments.forEach(groupEnrolment => {
        groupEnrolment.Enrolments.forEach(enrolment => {
          enrolment.isInfoIncomplete = (!enrolment.FirstName || !enrolment.LastName || !enrolment.EmailAddress || !enrolment.Phone)
        })
        isLearnerInfoIncomplete = groupEnrolment.Enrolments.some(x => x.isInfoIncomplete == true)
        if (isLearnerInfoIncomplete) this.isLearnersDetailsInComplete = isLearnerInfoIncomplete;
      })
    }
    return this.isLearnersDetailsInComplete;
  }

  checkIfSeletedLearnerIncompleteInfo(): void { 
    let isSelectedLearnerInfoIncomplete = false;
    this.selectedLearnerIds.forEach(registrationid => {
      this.classEnrollments.forEach(groupEnrolment => {
        groupEnrolment.Enrolments.forEach(enrollment => {
          if (registrationid == enrollment.RegistrationId) {
            if (enrollment.isInfoIncomplete) isSelectedLearnerInfoIncomplete = true;
          }
        })
      })
    })
    this.canDisableSubmitROC = isSelectedLearnerInfoIncomplete;
  }
}
